import React from 'react'
import SimilarJobItem from './SimilarJobItem'
const SimilarJobs = ({items}) => {
    return (
    <>
        {items.map( item => (<SimilarJobItem />))}
    </>
)}
export default SimilarJobs